import { STORAGE_MAKEORDER_LOGIN_TYPE } from '@/utils/train-storage'
import { getStorage } from '@/utils/storage'

export default {
	is_exemption: getStorage(STORAGE_MAKEORDER_LOGIN_TYPE) || 0, // 0-12306流程 1-免登录流程
	makeOrderBaseInfo: {},
	showNormalRetentionDrawer: false, // 普通购票挽留权益弹窗
	showScrambleRetentionDrawer: false, // 抢票挽留权益弹窗
	scrambleBtnTrackType: 'normal', // 抢票按钮埋点类型
	rightCardType: 'null', // 权益卡片样式类型
	addedServiceSource: [], // 记录附加服务来源（辅营+加速包）
}
